/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_cfc19ca6"]'><div :class='["update-data-picker-wrapper"]'><div :class='["picker-demo-title"]'>update-data-picker:</div><cube-picker ref="__mpx_ref_picker__" :list="(dataList)" :selected-index="(selectedIndex)"/><div :class='["button-wrapper"]'><cube-button @_click="update">更新选项</cube-button></div><div :class='["button-wrapper"]'><cube-button @_click="getSelected">获取选中值</cube-button></div><div :class='["demo-data"]' v-if="(selectedInfo.length)"><div :class='["value"]'><div v-for="(item, index) in (selectedInfo)" :key="item.index" :class='["value-item"]'><div :class='["item-key"]'>{{item[0]}}</div><div :class='["item-value"]'>{{item[1]}}</div></div></div></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_cfc19ca6"}'>
.update-data-picker-wrapper
  .picker-demo-title
    margin-bottom: 8px
  .button-wrapper
    margin-top: 10px
  .demo-data
    margin-top: 10px
    padding: 10px 10px
    background-color: white
    border: 1px solid  white
    border-radius: 10px
  .key
    margin-bottom: 10px
    font-size: 16px
  .key-introduce
    margin-bottom: 10px
    line-height: 20px
  .value
    margin-bottom: 20px
    white-space: break-spaces
    .value-item
      display flex
      justify-content: space-between
      height: 25px
      line-height: 25px
      font-size: 15px
      .item-value
        white-space nowrap
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_cfc19ca6"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_cfc19ca6"}
  /** script content **/
  require("./api-picker.mpx.js?isComponent&outputPath=components%2Fapi-pickercfc19ca6%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./api-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fapi-pickercfc19ca6%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_cfc19ca6"],
    ctorType: "component",
    outputPath: "components/api-pickercfc19ca6/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-picker':getComponent(require("../../../packages/mpx-cube-ui/src/components/picker/index.mpx?isComponent&outputPath=components%2Findex3b508115%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>